import { trimCalendarDate } from './calendar'
import { DangerousState } from '../enum'

export const defaultDatetimeFilterState = (value = '') => ({
  date: value === '' ? value : trimCalendarDate(value),
  time: ''
})

export const defaultChartDatetimeState = (value = '') => ({
  date: value,
  time: ''
})

export const defaultDurationFilterState = () => ({
  seconds: null,
  minutes: null,
  hours: null,
  days: null
})

export const defaultRangeFilterState = () => ({
  type: 'range',
  value: [0, 0], // default values - all data will be visible, will be updated later after server call
  minServerValue: 0,
  maxServerValue: 0 // max count - will be fetched from server
})

// export const usedDangerousStates = () => Object.assign({}, DangerousState, {
//   [DangerousState.CAMERA_OFF]: undefined,
//   [DangerousState.UNKNOWN]: undefined,
//   [DangerousState.YAWNING]: undefined
// })

export const usedDangerousStates = () => {
  let data = Object.assign({}, DangerousState)
  const { YAWNING, UNKNOWN, CAMERA_OFF, ...rest } = data

  return rest
}
